import styled from 'styled-components'

export const Container = styled.button`
  font-size: 14px;
  color: ${({ theme }) => theme.colors.gray[900]};
  font-family: 'DM Sans';
`
